import { AUTH_ROUTES, PERSONAL_AREA_NAME } from '@/config/constants'

export const mainMenu = [
  { label: 'About', href: '/#about', anchorID: 'about' },
  // {
  //   label: 'Alumni Stories',
  //   href: '/#alumni-stories',
  //   anchorID: 'alumni-stories',
  // },
  // {
  //   label: 'How to participate',
  //   href: '/#how-to-participate',
  //   anchorID: 'how-to-participate',
  // },
  // { label: 'Archive', href: '/#archive', anchorID: 'archive' },
  {
    label: 'Active Competitions',
    href: '/#active-competitions',
    anchorID: 'active-competitions',
  },
  { label: 'FAQ', href: '/#faq', anchorID: 'faq' },
]

export const loggedMenu = [
  {
    label: 'personalArea',
    href: `/${PERSONAL_AREA_NAME}`,
  },
  {
    label: 'logout',
    href: AUTH_ROUTES.logout,
    'data-color': 'danger',
  },
]
